<template lang="pug">
  section.av-banner.campaign-banner.dark(
    v-if="campaignCopy"
    role="complementary"
    aria-labelledby="banner-heading"
  )
    div
      span.emoji {{ campaignCopy.emoji }}
      span.mobile-text
        | {{ campaignCopy.mobile.text }}
        span
          a.cta-link(
            v-if="campaignCopy.mobile.cta !== undefined"
            href="/removals/student-movers"
            @click="() => handleCTAClick('mobile')"
          ) {{ campaignCopy.mobile.cta }}
      span.desktop-text
        | {{ campaignCopy.desktop.text }}
        span
          a.cta-link(
            v-if="campaignCopy.desktop.cta !== undefined"
            href="/removals/student-movers"
            @click="() => handleCTAClick('desktop')"
          ) {{ campaignCopy.desktop.cta }}
</template>

<script setup lang="ts">
import { useNuxtApp } from "#app"
import "@anyvan-ui/banner/index.css"

type CampaignCopy = {
  id: string
  emoji: string
  mobile: {
    text: string
    cta: string
  }
  desktop: {
    text: string
    cta: string
  }
} | null

const props = defineProps<{
  campaignCopy: CampaignCopy
}>()

const { $snowplow } = useNuxtApp()

const handleCTAClick = (device: "mobile" | "desktop") => {
  if (props.campaignCopy) {
    $snowplow.trackLinkClick(
      `${props.campaignCopy.id} Campaign: ${device}`,
      "/removals/student-movers"
    )
  }
}
</script>

<style>
.mobile-text {
  @apply inline;
}

.desktop-text {
  @apply hidden;
}

@screen md {
  .mobile-text {
    @apply hidden;
  }

  .desktop-text {
    @apply inline;
  }
}

a.cta-link {
  @apply ml-ds-xxs;
}
</style>
